import { Months } from "../../../common/constants/months_and_years";
import { Years } from "../../../common/constants/months_and_years";
import { States } from "../../../common/constants/states";
import { formatDriveForDisplay } from "../../../common/types/drive.types";

class InstructorStudentDrivesController {
  constructor($stateParams, UsersModel, FlashService, student, UserService) {
    this.$stateParams = $stateParams;
    this.student = student;
    this.loading = true;
    this.UsersModel = UsersModel;
    this.FlashService = FlashService;
    this.payment = {};
    this.drives = [];
    this.addresses = [];
    this.order = null;
    this.months = Months;
    this.years = Years;
    this.states = States;
    this.currentPage = 1;
    this.totalItems = 0;
    this.UserService = UserService;
    this.currentUser = UserService.getCurrentUser();

    this.options = {
      id: this.student.id,
      page_results: true,
    };

    this.getDrives();
  }

  pageChanged() {
    this.getDrives();
  }

  getDrives() {
    this.submitted = true;
    this.UsersModel.getStudentDrives(this.options).then((response) => {
      this.totalItems = response.drives.total;
      this.currentPage = response.drives.current_page;
      this.drives = response.drives.filter((drive) => {
        Object.assign(drive, formatDriveForDisplay(drive));
        if (drive.observation === true) {
          drive.type.name = drive.type.name + " (Observation)";
        }
        return drive;
      });
    });
  }
}

InstructorStudentDrivesController.$inject = [
  "$stateParams",
  "UsersModel",
  "FlashService",
  "student",
  "UserService",
];
export default InstructorStudentDrivesController;
